import {
  Box,
  Flex,
  Skeleton,
  Image,
  Text,
  useTheme,
  Icon,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import Nodata from "../../components/Nodata";

const FeedBack = () => {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");

  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [feedback, setFeedback] = React.useState<any>([]);
  const [totalPages, setTotalPages] = React.useState<number>();
  const [total, setTotal] = React.useState<number>();

  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);

  const [pageNumber, setPageNumber] = React.useState(() => {
    return Number(localStorage.getItem("feedbackpage")) || 1;
  });

  const getAllFeedBack = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setFeedback(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setTotal(res.data.pagination.total);
      if (res.data.length < 20) {
        setNextNotAllowed(true);
      } else {
        setNextNotAllowed(false);
      }
    } catch (error) {
      console.log("error listing users", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  React.useEffect(() => {
    getAllFeedBack(`/feedback?page=${pageNumber}`);
  }, [pageNumber]);

  React.useEffect(() => {
    if (totalPages && totalPages === pageNumber) {
      setNextNotAllowed(true);
    } else {
      setNextNotAllowed(false);
    }
  }, [totalPages]);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Flex
        sx={{
          margin: "2.5rem 0 2rem 2rem",
          gap: "1rem",
          alignItems: "baseline",
        }}
      >
        <Text
          sx={{
            fontSize: theme.fontSizes.subHeading1,
          }}
        >
          User Feedback
        </Text>
        <Flex sx={{ flex: 1, justifyContent: "flex-end" }}>
          <Text
            sx={{
              fontSize: theme.fontSizes.body,
              marginRight: "0.25rem",
            }}
          >
            Total:
          </Text>
          <Skeleton isLoaded={!isDataFetching}>
            <Text
              sx={{
                fontSize: theme.fontSizes.body,
                color: "green",
              }}
            >
              {total}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>
      <Box sx={{ marginTop: "1rem", paddingX: "2rem", width: "70%" }}>
        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {feedback && feedback.length !== 0 ? (
            feedback?.map((item: any, index: number) => {
              return (
                <Box
                  sx={{
                    gap: "0.5rem",
                    border: "1px solid",
                    borderColor: theme.colors.divider,
                    marginBottom: "1rem",
                    padding: "1rem",
                    borderRadius: "0.5rem",
                  }}
                  key={index}
                >
                  <Flex sx={{ gap: "0.5rem" }}>
                    <Text sx={{ color: theme.colors.secondary.light }}>
                      Subject:
                    </Text>
                    <Text sx={{ fontWeight: 600 }}>
                      {item?.subject || "-----------"}
                    </Text>
                  </Flex>

                  <Flex sx={{ gap: "0.5rem" }}>
                    <Text sx={{ color: theme.colors.secondary.light }}>
                      Message:
                    </Text>
                    <Text sx={{ fontWeight: 600 }}>
                      {item?.message || "-----------"}
                    </Text>
                  </Flex>

                  <Flex sx={{ gap: "0.5rem" }}>
                    <Text sx={{ color: theme.colors.secondary.light }}>
                      User name:
                    </Text>
                    <Text sx={{ fontWeight: 600 }}>
                      {item?.rider_name || "-----------"}
                    </Text>
                  </Flex>
                  <Flex sx={{ gap: "0.5rem" }}>
                    <Text sx={{ color: theme.colors.secondary.light }}>
                      User mobile:
                    </Text>
                    <Text sx={{ fontWeight: 600 }}>
                      {item?.rider_mobile || "-----------"}
                    </Text>
                  </Flex>
                </Box>
              );
            })
          ) : (
            <Nodata heading="No Feedback Listed" />
          )}
        </Skeleton>
        <Box
          sx={{
            marginTop: theme.space.xl,
          }}
        >
          <Flex
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "3rem",
            }}
          >
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowBackIosNew}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                    onClick={() => {
                      if (pageNumber !== 1) {
                        setPageNumber(pageNumber - 1);
                        localStorage.setItem(
                          "feedbackpage",
                          `${pageNumber - 1}`,
                        );
                      }
                    }}
                  />
                </Flex>
                <Text variant={"caption"}>Previous Page</Text>
              </Flex>
            </Box>
            <Skeleton
              isLoaded={isDataFetching ? false : true}
              sx={{ width: "2rem" }}
            >
              <Text variant={"body"}>{pageNumber}</Text>
            </Skeleton>
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Text variant={"caption"}>Next Page</Text>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowForwardIos}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                    onClick={() => {
                      if (!nextNotAllowed) {
                        setPageNumber(pageNumber + 1);
                        localStorage.setItem(
                          "feedbackpage",
                          `${pageNumber + 1}`,
                        );
                      }
                    }}
                  />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default FeedBack;
